import { Component, Input } from '@angular/core';

import { UserVerificationProvider } from '../../providers/user-verification/user-verification';
import { ToolsProvider } from '../../providers/tools/tools';

@Component({
  selector: 'verification-drawer-prompts',
  templateUrl: 'verification-drawer-prompts.html',
})
export class VerificationDrawerPromptsComponent {
  showPrompt = true;
  constructor(
    public verification: UserVerificationProvider,
    public tools: ToolsProvider
  ) {}

  ngOnInit() {
    // on launch not allowing user to hide if not verified
    // this.tools.on('open-main-drawer', () => {
    //   this.showPrompt = this.checkToShowPrompt();
    // });
  }

  getVerified() {
    this.verification.showGetVerifiedOverlay();
  }

  hidePrompt() {
    const nowInHours = Math.floor(new Date().getTime() / (1000 * 60 * 60));
    localStorage.setItem('verificationPromptLastHidden', nowInHours.toString());
    this.showPrompt = false;
  }

  checkToShowPrompt() {
    const lastHidden = localStorage.getItem('verificationPromptLastHidden');

    if (!lastHidden) {
      return true;
    }

    const currentTimeInHours = Math.floor(
      new Date().getTime() / (1000 * 60 * 60)
    );
    const timeDifference = currentTimeInHours - parseInt(lastHidden, 10);

    const oneDayInHours = 24;

    if (timeDifference >= oneDayInHours) {
      return true;
    }

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/components/verification-drawer-prompts/verification-drawer-prompts.ts